import React from "react";

const DetailsModal = ({ isOpen, onClose, title, data }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-800 rounded-lg max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col">
        <div className="flex justify-between items-center p-4 border-b border-gray-600">
          <h3 className="text-lg font-semibold text-white">{title}</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white text-2xl w-8 h-8 flex items-center justify-center"
          >
            ×
          </button>
        </div>
        <div className="p-4 overflow-y-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {Object.entries(data).map(([key, value]) => (
              <div key={key} className="bg-gray-700 rounded-lg p-3">
                <span className="text-gray-400 text-xs block mb-1">{key}:</span>
                <p
                  className={`font-medium text-sm ${
                    value === "true"
                      ? "text-green-400"
                      : value === "false"
                      ? "text-red-400"
                      : "text-white"
                  }`}
                >
                  {value}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsModal;